import _taggedTemplateLiteral from "/home/circleci/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject12() {
  var data = _taggedTemplateLiteral(["\n  grid-column: section-label;\n  color: var(", ");\n  ", ";\n"]);

  _templateObject12 = function _templateObject12() {
    return data;
  };

  return data;
}

function _templateObject11() {
  var data = _taggedTemplateLiteral(["\n  display: inline-block;\n  grid-column: section-icon;\n  margin-inline-end: var(", ");\n\n  width: 24px;\n  height: 24px;\n"]);

  _templateObject11 = function _templateObject11() {
    return data;
  };

  return data;
}

function _templateObject10() {
  var data = _taggedTemplateLiteral(["\n  --inset: var(", ");\n\n  box-sizing: border-box;\n  padding: var(--inset);\n\n  transform: ", ";\n  opacity: ", ";\n\n  transition-delay: ", "ms;\n  transition-timing-function: var(", ");\n  transition-duration: ", "ms;\n  transition-property: transform, opacity;\n"]);

  _templateObject10 = function _templateObject10() {
    return data;
  };

  return data;
}

function _templateObject9() {
  var data = _taggedTemplateLiteral(["\n  --panel-height: ", ";\n\n  box-sizing: border-box;\n  height: var(--panel-height);\n  overflow: hidden;\n\n  background-color: var(", ");\n  visibility: ", ";\n\n  transition: ", "ms var(", ");\n  transition-property: height, visibility;\n"]);

  _templateObject9 = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8() {
  var data = _taggedTemplateLiteral(["\n  grid-column: arrow-icon;\n  grid-row: 1 / span 3;\n  align-self: center;\n\n  width: 24px;\n  height: 24px;\n\n  transform: rotateZ(", "deg);\n\n  transition: transform 200ms var(", ");\n\n  pointer-events: none;\n\n  [dir='rtl'] & {\n    transform: rotateZ(", "deg);\n  }\n"]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = _taggedTemplateLiteral(["\n  display: grid;\n  grid-template-columns:\n    [section-icon] minmax(0, max-content)\n    [section-label] auto\n    [arrow-icon] max-content;\n  padding: var(", ")\n    var(", ");\n\n  color: var(", ");\n\n  &:hover {\n    color: var(", ");\n  }\n\n  &:focus {\n    color: var(", ");\n  }\n"]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n  all: revert;\n\n  display: block;\n  width: 100%;\n  margin: 0;\n  padding: 0;\n\n  text-align: start;\n\n  background: transparent;\n  border: solid var(", ");\n  border-width: 1px 0;\n\n  cursor: pointer;\n\n  appearance: none;\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n  color: var(", ");\n\n  ", ";\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  grid-column: section-label;\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  display: grid;\n  grid-column: section-label;\n\n  color: var(", ");\n\n  &:hover {\n    color: var(", ");\n  }\n\n  transition: transform 200ms var(", ");\n  margin-inline-end: var(", ");\n\n  ", "\n\n  @media (max-width: 439px) {\n    hyphens: auto;\n  }\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  all: revert;\n\n  margin: 0;\n\n  &:not(:first-child) {\n    margin-top: -1px;\n  }\n\n  &:focus-within {\n    z-index: 1;\n  }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  justify-content: stretch;\n\n  ", "\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

// eslint-disable-next-line import/named
import styled from 'styled-components';
import { injectSpacing } from '../../api/spacing/injectSpacing';
import { injectTypography } from '../../utils/injectTypography';
var styledAccordionStateConfig = {
  shouldForwardProp: function shouldForwardProp(prop) {
    return !['open', 'defaultOpen'].includes(prop);
  }
};
export var StyledAccordion = styled.div(_templateObject(), injectSpacing('margin'));
export var StyledSectionHeader = styled.h2(_templateObject2());
export var StyledSectionHeaderLabel = styled.span(_templateObject3(), function (props) {
  return props.theme.colors.interaction.label.default;
}, function (props) {
  return props.theme.colors.interaction.label.hover;
}, function (props) {
  return props.theme.easing;
}, function (props) {
  return props.theme.responsive.spacing.m;
}, function (props) {
  return injectTypography(props, 'copy1');
});
export var StyledSectionHeaderHint = styled.span(_templateObject4());
export var StyledSectionHeaderHintLabel = styled.span(_templateObject5(), function (props) {
  return props.theme.colors.ui.tertiary;
}, function (props) {
  return injectTypography(props, 'copy2');
});
export var StyledSectionHeaderButton = styled.button(_templateObject6(), function (props) {
  return props.theme.colors.ui.divider;
});
export var StyledSectionHeaderButtonContent = styled.span(_templateObject7(), function (props) {
  return props.theme.responsive.spacing.m;
}, function (props) {
  return props.theme.responsive.spacing.l;
}, function (props) {
  return props.theme.colors.interaction.label.default;
}, function (props) {
  return props.theme.colors.interaction.label.hover;
}, function (props) {
  return props.theme.colors.interaction.label.focus;
});
export var StyledIcon = styled.svg.withConfig(styledAccordionStateConfig)(_templateObject8(), function (props) {
  return props.open ? -180 : 0;
}, function (props) {
  return props.theme.easing;
}, function (props) {
  return props.open ? 180 : 0;
});
var transitionDuration = 400;
export var StyledSectionPanel = styled.div.withConfig(styledAccordionStateConfig)(_templateObject9(), function (props) {
  return props.defaultOpen ? 'auto' : '0px';
}, function (props) {
  return props.theme.colors.ui.highlight.tertiary;
}, function (props) {
  return props.open ? 'visible' : 'hidden';
}, transitionDuration, function (props) {
  return props.theme.easing;
});
export var StyledSectionPanelContent = styled.div.withConfig(styledAccordionStateConfig)(_templateObject10(), function (props) {
  return props.theme.responsive.spacing.l;
}, function (props) {
  return !props.open && 'translateY(calc(var(--inset) / 2))';
}, function (props) {
  return props.open ? 1 : 0;
}, function (props) {
  return props.open ? transitionDuration * 0.2 : 0;
}, function (props) {
  return props.theme.easing;
}, transitionDuration * 0.8);
export var StyledIconContainer = styled.span(_templateObject11(), function (props) {
  return props.theme.responsive.spacing.m;
});
export var StyledSublineContainer = styled.span(_templateObject12(), function (props) {
  return props.theme.colors.ui.tertiary;
}, function (props) {
  return injectTypography(props, 'copy2');
});